import React, { useEffect, useState } from "react";
import { Card, CardContent, Box, Button, Tabs, Tab } from "@mui/material";
import * as services from "./../../services/customer";
import * as localServices from "./../../services/local";
import toast, { Toaster } from "react-hot-toast";
import AppBreadcrumbs from "../../components/AppBreadcrumbs";
import PersonalInfoForm from "./personal_Info_form";
import PaymentInfoForm from "./persnal_payment_form";
import { useNavigate, useSearchParams } from "react-router-dom";
import * as salengServices from "./../../services/saleng";

const { v4: uuidv4 } = require("uuid");

const CustomerForm = () => {
  const [searchParams] = useSearchParams();
  const sale = searchParams.get("sale") === "true";

  const [group, setGroup] = useState("");
  const [personType, setPersonType] = useState("normal");

  const [cars, setCars] = useState([]); // { type, license, province }
  const [drivers, setDrivers] = useState([]); // { name, surname, idCard }

  const [tabIndex, setTabIndex] = useState(0);
  const [customerGroups, setCustomerGroups] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    citizenId: "",
    phone: "",
    address: "",
    img: "",
    dob: "",
  });

  const navigate = useNavigate();

  useEffect(() => {
    fetchGroup();
  }, []);

  const fetchGroup = async () => {
    try {
      const res = await services.getGroup();
      const rawData = res.data?.data || [];
      const mapped = rawData.map((g) => ({
        id: g.id,
        name: g.name || "-",
      }));
      setCustomerGroups(mapped);
    } catch (error) {
      console.error("Error fetching customers:", error);
    }
  };

  const readCard = async () => {
    try {
      const res = await localServices.readCard();
      const data = res.data.data;
      setFormData((prev) => ({
        ...prev,
        name: `${data.firstNameTH} ${data.lastNameTH}`,
        dob: data.birthday,
        citizenId: data.citizenId,
        address: data.address,
        img: data.photo,
      }));
      console.log("ข้อมูลบัตร:", res.data);
    } catch (err) {
      console.error("err:", err);
      alert("ไม่สามารถอ่านบัตรได้");
    }
  };

  const handleChange = (field) => (event) => {
    setFormData((prev) => ({ ...prev, [field]: event.target.value }));
  };

  const handleTabChange = (_, newValue) => setTabIndex(newValue);

  // ============ Cars ============
  // รองรับทั้งเรียกแบบไม่มีพารามฯ (เพิ่มเปล่า) และแบบ Dialog ส่งอ็อบเจ็กต์มา
  const handleAddCar = (car) => {
    if (car && typeof car === "object") {
      setCars((prev) => [...prev, car]);
    } else {
      setCars((prev) => [...prev, { type: "", license: "", province: "" }]);
    }
  };
  const handleDeleteCar = (index) => {
    setCars((prev) => prev.filter((_, i) => i !== index));
  };
  const handleCarChange = (index, field, value) => {
    setCars((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  // ============ Drivers ============
  const handleAddDriver = (driver) => {
    if (driver && typeof driver === "object") {
      // กัน key พิมพ์ผิด
      const normalized = {
        name: driver.name || "",
        surname: driver.surname || driver.suername || "", // เผื่อกรณีเก่าพิมพ์ตก
        idCard: driver.idCard || "",
      };
      setDrivers((prev) => [...prev, normalized]);
    } else {
      setDrivers((prev) => [...prev, { name: "", surname: "", idCard: "" }]);
    }
  };
  const handleDeleteDriver = (index) => {
    setDrivers((prev) => prev.filter((_, i) => i !== index));
  };
  const handleDriverChange = (index, field, value) => {
    setDrivers((prev) => {
      const next = [...prev];
      next[index] = { ...next[index], [field]: value };
      return next;
    });
  };

  const handleSubmit = async () => {
    try {
      // อัปโหลดรูปถ้าเป็น base64
      if (formData.img && isBase64(formData.img)) {
        const blob = base64ToBlob(formData.img);
        const form = new FormData();
        form.append("file", blob, "image.png");
        const response = await services.upload(form);
        formData.img = response.data.file; // ใส่ URL ไฟล์หลังอัปโหลด
      }

      const payload = {
        ...formData,
        personType,
        cars,
        drivers,
        ...(group !== "" && { customerGroupId: Number(group) }),
        // ✅ แจ้งฝั่งเซิร์ฟเวอร์ว่าเป็นซัพพลายเออร์ขายของ
        customerType: "SELLER",
        // NOTE: shopId/branchId ถ้ามี context ควรยัดมาด้วยจาก store หรือ props
      };

      const res = await services.createCustomer(payload);
      const data = res.data;
      console.log('data',data);
      if (data.success) {
        toast.success("เพิ่มรายการสำเร็จ!");

        if (sale) {
          const customer = data.data;

          const payload = {
            transactionId: uuidv4(),
            customerId: customer.id,
            // carId: customer.cars?.id,
            // driverId: customer.drivers?.id,
            customerName: customer.name,
            status: "waiting",
          };
          const response = await salengServices.createSaleTransaction(payload);
          console.log('response',response);
          navigate(
            `/sale/checkout?id=${response.data.data.transactionId}&ticket=${response.data.data.billNumber}&status=${response.data.data.status}`
          );
        } else {
          // navigate(`/sale/customers`);
        }
      } else {
        toast.error(data.error);
      }
    } catch (err) {
      toast.error("เพิ่มรายการไม่สำเร็จ!");
      console.error("Error creating customer:", err);
    }
  };

  function isBase64(str) {
    return (
      typeof str === "string" && /^data:image\/[a-zA-Z]+;base64,/.test(str)
    );
  }
  function base64ToBlob(base64, mimeType = "image/png") {
    const byteString = atob(base64.split(",")[1]);
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++)
      ia[i] = byteString.charCodeAt(i);
    return new Blob([ab], { type: mimeType });
  }

  return (
    <Box p={2}>
      <AppBreadcrumbs />
      <Toaster position="bottom-right" reverseOrder={false} />

      <Box sx={{ maxWidth: 1000, mx: "auto", mt: 4 }}>
        <Card sx={{ mb: 4 }}>
          <CardContent>
            <Tabs value={tabIndex} onChange={handleTabChange} centered>
              <Tab label="ข้อมูลส่วนตัว" />
              <Tab label="การชำระเงิน" />
            </Tabs>

            {tabIndex === 0 && (
              <Box sx={{ mt: 2 }}>
                <PersonalInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  // ✅ ต่อกับ Dialog ใน PersonalInfoForm
                  cars={cars}
                  drivers={drivers}
                  handleAddCar={handleAddCar}
                  handleAddDriver={handleAddDriver}
                  handleDeleteCar={handleDeleteCar}
                  handleDeleteDriver={handleDeleteDriver}
                  handleCarChange={handleCarChange}
                  handleDriverChange={handleDriverChange}
                />
              </Box>
            )}

            {tabIndex === 1 && (
              <Box sx={{ mt: 2 }}>
                <PaymentInfoForm
                  formData={formData}
                  handleChange={handleChange}
                  readCard={readCard}
                  customerGroups={customerGroups}
                  group={group}
                  setGroup={setGroup}
                  personType={personType}
                  setPersonType={setPersonType}
                  // ถ้าฟอร์มชำระเงินต้องโชว์รถ/แก้ด้วย ก็ส่ง props ให้เหมือนกัน
                  cars={cars}
                  handleAddCar={handleAddCar}
                  handleDeleteCar={handleDeleteCar}
                  handleCarChange={handleCarChange}
                  // บางโปรเจกต์สะกดพร็อปนี้ผิดไว้ เดี๋ยวส่ง alias ไปด้วยกันเซฟ ๆ
                  handleDriverChange={handleDriverChange}
                  handleDriverChang={handleDriverChange}
                />
              </Box>
            )}

            <Box sx={{ mt: 4, display: "flex", justifyContent: "center" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleSubmit}
              >
                บันทึกข้อมูล
              </Button>
            </Box>
          </CardContent>
        </Card>
      </Box>
    </Box>
  );
};

export default CustomerForm;
